<template>
    <main class="LoginDisplay-MAIN" v-if="showView">
        
        <section v-if="showView">
            <div>
                <img src="../assets/bbva-logo.png"/>
                <img src="../assets/mis-promos-login.png"/>
                <p>¡Los mejores descuentos y <br/>promociones para <br/>Colaboradores BBVA!</p>
            </div>
            <div>
                <img src="../assets/login-icons.png"/>
            </div>
            <img src="../assets/btn-descubre-mas.png" @click="toSaml()"/>
            <hr/>
        </section>

    </main>
</template>

<script>
export default {
    name: 'LoginDisplay',
    data(){
        return{
            MInput: '',
            showView: false,
        }
    },
    methods:{
        getFrontURL(){
			return window.location.origin;
		},

        async toSaml(){
            window.location.href = "https://saml-promociones.ideeo.mx/";
        },
        
        async getUserSessionData(){
            let params = new URLSearchParams(document.location.search);
            let token = params.get("_token");
            console.log(`getUserSessionData. Token: (${token}). Se redirigirá en 10s`);
            if(token){
                const response = await fetch('https://promo-colaboradores.ideeo.mx/api/sesion', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token: token
                    })
                });
                const result = await response.json();

                if(result.msg == "Token activo"){
                    localStorage.setItem("userData", JSON.stringify(result.data));
                    localStorage.setItem("m_usuario", result?.m_usuario);
                    //setTimeout(() => {
                        window.location.href = this.getFrontURL() + "/home";
                    //}, 10_000);
                }else{
                    alert("La sesión no existe o ha caducado.");
                }
            }
        },
        
    },
    beforeMount(){
        let params = new URLSearchParams(document.location.search);
        let token = params.get("_token");
        if(!token){
            console.log(`beforeCreate. No se encontró token (${token}). Se redirigirá al saml en 10s.`);
            //setTimeout(() => {
                window.location.href = "https://saml-promociones.ideeo.mx/";
            //}, 10_000);
        }
    },
    mounted(){
        this.getUserSessionData()
        .catch(error => {
            console.error(error);
            setTimeout(() => {
                window.location.reload();
            }, 5_000);
            //alert("Error de red / servidor. Intenta de nuevo en unos segundos.");
        });
    }
}
</script>

<style scoped lang="stylus">
.LoginDisplay-MAIN
    width: 100%
    min-height: 100vh
    background-image: url('../assets/bg.webp')
    background-size: cover
    background-position: top center
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    font-family: 'Benton Sans BBVA Book'
    font-size: 1.6ch

section
    background-color: white
    display: flex
    align-items: center
    height: 55ch
    width: 100ch
    border-radius: 2ch
    position: relative

    div
        width: 50%
        height: 100%
        display: flex
        align-items: center
        justify-content: center

        &:nth-child(1)
            position: relative
            flex-direction: column

            >img:nth-child(1)
                position: absolute
                width: 12ch
                top: 3ch
                left: 3ch

            >img:nth-child(2)
                width: 60%

            >p
                color: #051283
                font-size: 2.2ch
                text-align: center
                margin-top: 4ch
                margin-bottom: -2ch

        &:nth-child(2)

            >img
                max-width: 60%
                max-height: 60%

    >img
        height: 5ch
        position: absolute
        margin: 0 auto
        left: 0
        right: 0
        bottom: -2ch
        cursor: pointer

    >hr
        position: absolute
        height: 75%
        width: 0
        top: 0
        bottom: 0
        left: 0
        right: 0
        margin: auto;
        border-left: 1px solid #051283

/* RESPONSIVE */
@media all and (max-width:780px)

    section
        max-width: 90%
        flex-direction: column

        div
            width: 100%

            &:nth-child(1)

                >img:nth-child(1)
                    width: 20vw
                    top: 2ch
                    left: 2ch

        
            &:nth-child(2)
                display: none

        >hr
            display: none
</style>